var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNounDelay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 29,
    viewBox: "0 0 36 29",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.109 6.342v9.017l3.857 2.725 1.183-1.585-2.983-2.13V6.341zM16.663 8.522c0-4.41-3.754-8.027-8.332-8.027C3.754.495 0 4.112 0 8.522c0 4.41 3.754 8.026 8.331 8.026 4.578-.05 8.332-3.616 8.332-8.026zm-9.36-4.657H9.36V9.86H7.303V3.865zm.823 9.562c-.052 0-.103-.05-.206-.05-.051 0-.103-.049-.206-.099-.051-.05-.103-.099-.154-.099-.051-.05-.103-.099-.103-.148-.051-.05-.051-.1-.103-.149-.051-.05-.051-.099-.051-.198v-.397c0-.05.051-.099.051-.198 0-.05.052-.099.103-.198.052-.05.052-.099.103-.149.051-.05.103-.099.154-.099.052-.05.103-.05.206-.099.051 0 .103-.05.206-.05h.411c.052 0 .154.05.206.05.051.05.103.05.154.1.052.049.103.098.154.098.052.05.103.1.103.15.052.049.052.098.103.197.052.05.052.1.052.198v.397c0 .05-.052.099-.052.198 0 .05-.051.1-.103.149-.051.05-.051.099-.103.148-.051.05-.102.1-.154.1-.051.049-.103.049-.154.099-.052.05-.103.05-.206.05h-.206c-.051.049-.154.049-.205 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.137 0c-2.006 0-3.908.396-5.606 1.09.566.446 1.08.99 1.543 1.536 1.286-.396 2.675-.644 4.063-.644 7.046 0 12.806 5.549 12.806 12.337 0 6.788-5.76 12.287-12.806 12.287-5.04 0-9.36-2.824-11.468-6.887-.412.05-.875.1-1.338.1-.308 0-.617 0-.925-.05 2.263 5.153 7.56 8.82 13.731 8.82 8.177 0 14.863-6.442 14.863-14.32S29.314 0 21.137 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNounDelay);
export default __webpack_public_path__ + "static/media/noun-delay.602a06933062ba4ea4f96a357903c45d.svg";
export { ForwardRef as ReactComponent };